import { subscribeChannel, publishChannel } from './channelUtils';

export function sendTheme(payload) {
    
    publishChannel('theme', payload);

}

export function listenTheme(callback) {

    return subscribeChannel(
        (event) => {

            const { tipo, payload } = event.data;

            if (tipo !== 'theme') {
                return;
            }

            callback(payload);

        }
    );

}